<section class="scr-page scr-page--compact home-page">
  <div class="scr-card">
    <tp-page-header
      variant="toolbar"
      title="Estado de prestadores"
      [subtitle]="onlineList.length + ' activos · ' + offlineList.length + ' inactivos'"
    >
      <div class="scr-search">
        <mat-icon class="scr-search__icon" aria-hidden="true">search</mat-icon>
        <input type="text" class="form-control" placeholder="Buscar prestador" aria-label="Buscar prestador" [(ngModel)]="searchText" />
      </div>
    </tp-page-header>

  <div class="collapse-panel online">
    <mat-accordion>
      <mat-expansion-panel [expanded]="onlinePanelOpenState">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon>visibility</mat-icon>
            <span>Activo</span>
            <span class="count tp-badge tp-badge--success">{{ onlineList.length }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="panel-content row m-0 p-0 py-2">
          <div class="col-12 py-2 pb-3 status-legend">
            @for (item of supplierStatusList; track $index) {
            <button type="button" class="custom-chip" [class.selected]="item.selected"
              (click)="item.selected = !item.selected" [style.border-color]="item.color" [style.color]="item.color"
              [style.background-color]="item.selected ? item.color : 'var(--tp-color-surface)'">
              <span class="align-middle">{{ item.name }}</span>
              <mat-icon class="align-middle">{{ item.icon }}</mat-icon>
            </button>
            }
          </div>

          <div class="col-xl-3 pb-4">
            <mat-selection-list #online [multiple]="false" class="active-list" hideSingleSelectionIndicator>
              @for (item of onlineList | filterByStatus : supplierStatusList | filterByName : searchText; track $index;
              let last = $last) {
              <mat-list-option (click)="onListItemClicked(item)">
                <div class="d-flex align-items-center w-100 py-2">
                  <div class="info-slot">
                    @if (selectedSuppier == item.id) {
                    <mat-icon title="Ver información" class="info-icon"
                      (click)="getSupplier(item); $event.stopPropagation()">info</mat-icon>
                    }
                  </div>
                  <div class="avatar-container mx-2">
                    <div class="avatar-img" [style.background-image]="'url(' + imageSvc.getImage(item.url) + ')'">
                      <div class="status-circle" [style.background-color]="imageSvc.getColorByStatus(item.stateId)">
                      </div>
                    </div>
                  </div>
                  <div class="description flex-grow-1 text-truncate px-2">
                    <span>{{ item.fullName }}</span>
                  </div>
                  <div class="status-icon" [style.background-color]="imageSvc.getColorByStatus(item.stateId)">
                    <mat-icon>{{ imageSvc.getIconByStatus(item.stateId) }}</mat-icon>
                  </div>
                </div>
              </mat-list-option>
              @if (!last) { <mat-divider></mat-divider> }
              }
            </mat-selection-list>
          </div>

          <div class="col-xl-9 map-container">
            <indu-map [markers]="markers | filterByStatus : supplierStatusList" [center]="center"
              [showInfoWindow]="true"></indu-map>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div class="collapse-panel offline">
    <mat-accordion>
      <mat-expansion-panel [expanded]="offlinePanelOpenState">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon>visibility_off</mat-icon>
            <span>Inactivo</span>
            <span class="count tp-badge tp-badge--neutral">{{ offlineList.length }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="panel-content row m-0 p-0 py-4">
          <div class="col-12 px-5">
            <mat-grid-list #offline [cols]="getNumberOfCols()" rowHeight="60px">
              @for (item of offlineList | filterByName : searchText; track $index) {
              <mat-grid-tile>
                <div class="d-flex align-items-center w-100">
                  <div class="info-slot">
                    <mat-icon title="Ver información" class="info-icon"
                      (click)="getSupplier(item)">info</mat-icon>
                  </div>
                  <div class="avatar-container mx-2">
                    <div class="avatar-img" [style.background-image]="'url(' + imageSvc.getImage(item.url) + ')'"></div>
                  </div>
                  <div class="description flex-grow-1 text-truncate px-2">
                    <span>{{ item.fullName }}</span>
                  </div>
                  <div class="status-icon status-icon--offline">
                    <mat-icon>visibility_off</mat-icon>
                  </div>
                </div>
              </mat-grid-tile>
              }
            </mat-grid-list>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  </div>
</section>
